export default class Attribute
{
  constructor(id, name, type) 
  {
    this.id = id;
    this.name = name;
    this.type = type;
  }    

  isValid()
  {
    return Boolean(this.name);
  }
}